<template>
  <main
    class="w-full min-h-screen flex flex-col justify-between bg-white dark:bg-dark-500 p-6 relative overflow-hidden transition-colors duration-300"
  >
    <!-- Decorative background glow -->
    <div
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-primary-500/10 dark:bg-primary-500/5 blur-[100px] rounded-full pointer-events-none z-0"
    ></div>

    <!-- Header with System Logo and Appearance/Language controls -->
    <header
      class="w-full flex flex-col sm:flex-row gap-4 justify-between items-center max-w-7xl mx-auto z-10"
    >
      <div class="flex items-center gap-3">
        <HealthLogo width="200" :color="logoColor" height="35" />
      </div>
    </header>

    <!-- Main Content Area -->
    <div class="flex-grow flex items-center justify-center py-12 z-10">
      <section class="flex flex-col items-center text-center max-w-lg px-4 space-y-8">
        <!-- 404 Illustration -->
        <div class="select-none flex justify-center mb-4">
          <img
            :src="image404"
            alt="404 Error"
            class="w-80 h-auto sm:w-[26rem] max-h-[280px] object-contain drop-shadow-md select-none pointer-events-none"
          />
        </div>

        <!-- Descriptive Text -->
        <div class="space-y-3">
          <h1
            class="text-3xl sm:text-4xl font-extrabold tracking-tight text-gray-900 dark:text-white"
          >
            {{ t("page_not_found") }}
          </h1>
          <p class="text-base text-gray-500 dark:text-gray-400 font-medium max-w-md">
            {{ t("page_not_found_desc") }}
          </p>
        </div>

        <!-- Actions -->
        <div class="flex flex-col sm:flex-row gap-4 justify-center w-full sm:w-auto pt-2">
          <HealthButton
            color="primary"
            size="px-6 py-3"
            :label="t('back_to_home')"
            label-class="block font-semibold"
            icon="material-symbols:home-outline-rounded"
            to="/exams"
          />
        </div>
      </section>
    </div>

    <!-- Footer -->
    <footer class="w-full text-center py-4 z-10">
      <p class="opacity-50 text-[10px] font-medium tracking-wide text-gray-600 dark:text-gray-300">
        &copy; {{ new Date().getFullYear() }} ZAFAZ health. {{ t("all_rights_reserved") }}
      </p>
    </footer>
  </main>
</template>

<script setup lang="ts">
  import { useRouter } from "vue-router";
  import { useI18n } from "vue-i18n";
  import { useColorMode } from "@vueuse/core";
  import { computed } from "vue";
  import { Icon } from "@iconify/vue";
  import HealthButton from "@/shared/components/utils/button/HealthButton.vue";
  import HealthLogo from "@/shared/components/utils/HealthLogo.vue";
  import ChangeLanguage from "@/app/header/change_language/ChangeLanguage.vue";
  import ChangeAppearance from "@/app/header/change_appearance/ChangeAppearance.vue";
  import image404 from "@/assets/images/404/404 Error-amico.svg";

  const { t } = useI18n();
  const router = useRouter();

  const { state } = useColorMode({
    initialValue: "light",
  });

  const logoColor = computed(() => {
    return state.value === "dark" ? "#ffffffff" : "#000000";
  });
</script>

<style scoped></style>
